module.exports = __webpack_public_path__ + "img/step5-01.7b976a7c.jpg";